const registry = require('../registry');

/**
 * @type {import('../registry').ExtractAccessFunction}
 */
function extractAccess(_hNode, options) {
    const { roles } = options;
    const { forAction } = _hNode;

    let spec = [];
    let access = {};

    // Ignore "getMore" forActions. They are necessary for general application usage.
    if (['getMore', 'refresh'].includes(forAction)) {
        return { spec, access };
    }

    let hNode = { ..._hNode };
    if (hNode.title === '+') {
        hNode.title = 'CREATE a new record';
    }

    // for any actionElement that is implemented, always add it to the spec and access:
    spec = registry.addSpec(spec, hNode, {});
    access = registry.addAccess(access, hNode, { roles });

    //don't care about children. Any that actionElements might have are irrelevant

    return { spec, access };
}

const actionElements = {
    DownloadButton: { extractAccess },
    Button: { extractAccess },
    ImportForm: { extractAccess }
};
registry.register('actionElements', actionElements);

module.exports = actionElements;
